import { render, staticRenderFns } from "./vpn.vue?vue&type=template&id=3ed26afa"
import script from "./vpn.vue?vue&type=script&lang=js"
export * from "./vpn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports